import { render, staticRenderFns } from "./ProductsTable.vue?vue&type=template&id=cc1f92fe&"
import script from "./ProductsTable.vue?vue&type=script&lang=js&"
export * from "./ProductsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/musili/musilidev/webroot/work-bmm/01_DEX/dex/front-end/web-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc1f92fe')) {
      api.createRecord('cc1f92fe', component.options)
    } else {
      api.reload('cc1f92fe', component.options)
    }
    module.hot.accept("./ProductsTable.vue?vue&type=template&id=cc1f92fe&", function () {
      api.rerender('cc1f92fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenant/views/Dashboard/Components/ProductsTable.vue"
export default component.exports